export class RegExpFilterParameter {
  constructor(public regExp: RegExp = null) {
  }

  filter(source: string): boolean {
    return !this.regExp
      || this.regExp.test(source);
  }

  clone(): RegExpFilterParameter {
    return new RegExpFilterParameter(this.regExp);
  }
}
